import { scopeType } from "../models/TrendingModelsV2";

/**
 * Get the duration in milliseconds for a given scope/period
 */
export const getScopeDuration = (scope: scopeType): number | null => {
	switch (scope) {
		case "1 min":
			return 1 * 60 * 1000;
		case "10 min":
			return 10 * 60 * 1000;
		case "30 min":
			return 30 * 60 * 1000;
		case "1 hour":
			return 1 * 60 * 60 * 1000;
		case "4 hours":
			return 4 * 60 * 60 * 1000;
		case "12 hours":
			return 12 * 60 * 60 * 1000;
		case "1 day":
			return 24 * 60 * 60 * 1000;
		case "3 days":
			return 3 * 24 * 60 * 60 * 1000;
		case "10 days":
			return 10 * 24 * 60 * 60 * 1000;
		case "custom":
			return null; // Custom doesn't have a fixed duration
		default:
			return null;
	}
};

/**
 * Calculate the end date based on start date and period
 */
export const calculateEndFromStart = (
	start: Date,
	scope: scopeType,
): Date | null => {
	const duration = getScopeDuration(scope);
	if (duration === null) return null;

	return new Date(start.getTime() + duration);
};

/**
 * Calculate the start date based on end date and period
 */
export const calculateStartFromEnd = (
	end: Date,
	scope: scopeType,
): Date | null => {
	const duration = getScopeDuration(scope);
	if (duration === null) return null;

	return new Date(end.getTime() - duration);
};

/**
 * Calculate both start and end dates to maintain the period duration
 * when one of them changes
 */
export const calculateCounterpartDate = (
	changedDate: Date,
	changedField: "start" | "end",
	scope: scopeType,
): { start: Date; end: Date } | null => {
	const duration = getScopeDuration(scope);

	// If custom scope, don't calculate counterpart
	if (duration === null) {
		return null;
	}

	if (changedField === "start") {
		return {
			start: changedDate,
			end: new Date(changedDate.getTime() + duration),
		};
	} else {
		return {
			start: new Date(changedDate.getTime() - duration),
			end: changedDate,
		};
	}
};
